export const FIELD_INFO = {
    name: {
        minLength: 1,
        maxLength: 255,
    },
    description: {
        minLength: 1,
        maxLength: 10000,
    },
    maxProductImages: 9,
    maxSkuImages: 3,
    maxImagesLevel: 'product_and_stock_unit',
} as const
